/* Three Oh Six — Inventory-Status-Badge (PDP + Quick-View)
   Aktualisiert .tos-inv-Elemente beim Variantenwechsel. Server-Render liefert
   den Initialzustand; dieses Script hält ihn aktuell (PubSub + Interval-Fallback). */
(function () {
  if (window.TOSInventoryStatus) return;
  window.TOSInventoryStatus = true;

  function apply(el) {
    // Coming Soon: Server-Label ("Coming Soon") stehen lassen, nicht durch
    // Bestandslogik ueberschreiben.
    if (el.getAttribute('data-coming-soon') === 'true') return;
    var inv, texts;
    try {
      inv = JSON.parse(el.getAttribute('data-inventory') || '{}');
      texts = JSON.parse(el.getAttribute('data-texts') || '{}');
    } catch (e) {
      return;
    }

    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 5;
    var showCount = el.getAttribute('data-show-count') !== 'false';

    // Variante im umgebenden Produktkontext finden (mehrinstanzfähig: PDP + Quick-View)
    var scope = el.closest('product-info') || el.closest('.product__info-container') || document;
    var input = scope.querySelector('input[name="id"]');
    var variantId = input ? String(input.value) : '';
    if (!inv[variantId]) {
      var urlV = new URLSearchParams(window.location.search).get('variant');
      if (urlV && inv[urlV]) variantId = urlV;
    }
    if (!inv[variantId]) return;
    if (el.getAttribute('data-current') === variantId) return;

    var d = inv[variantId];
    var state, label;
    if (d.m !== 'shopify') {
      state = 'in';
      label = texts.in_stock;
    } else if (d.q <= 0) {
      if (d.p === 'continue') {
        state = 'in';
        label = texts.in_stock;
      } else {
        state = 'out';
        label = texts.sold_out;
      }
    } else if (d.q === 1) {
      // Genau 1 Stück: immer die Zahl zeigen, unabhängig von show_count
      state = 'low';
      label = texts.low_one;
    } else if (d.q <= threshold) {
      state = 'low';
      label = showCount ? String(texts.low_count || '').replace('[count]', d.q) : texts.low_stock;
    } else {
      state = 'in';
      label = texts.in_stock;
    }

    el.setAttribute('data-state', state);
    el.setAttribute('data-current', variantId);
    var t = el.querySelector('.tos-inv__text');
    if (t && label) t.textContent = label;
  }

  function tick() {
    var els = document.querySelectorAll('.tos-inv[data-inventory]');
    for (var i = 0; i < els.length; i++) apply(els[i]);
  }

  var pubsubTries = 0;
  function subscribePubSub() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(tick, 30);
      });
    } else if (++pubsubTries < 25) {
      setTimeout(subscribePubSub, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  subscribePubSub();
  setInterval(tick, 600);
})();
